import * as TYPES from "./Containers.types";

export const initialState = {
  appHome: {},
  loading: false,
  error: false,
};

const reducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case TYPES.FETCH_APP_HOME: {
      return {
        ...state,
        loading: true,
      };
    }
    case TYPES.FETCH_APP_HOME_SUCCESS: {
      return {
        ...state,
        loading: false,
        appHome: action.result,
      };
    }
    case TYPES.FETCH_APP_HOME_FAIL: {
      return {
        ...state,
        loading: false,
        error: true,
      };
    }
    case TYPES.FETCH_TICKER: {
      return {
        ...state,
        loading: true,
      };
    }
    case TYPES.FETCH_TICKER_SUCCESS: {
      return {
        ...state,
        loading: false,
        ticker: action?.result?.content,
      };
    }
    case TYPES.FETCH_TICKER_FAIL: {
      return {
        ...state,
        loading: false,
      };
    }

    default:
      return state;
  }
};

export default reducer;
